export function isNumericId(value) {
  return /^\d+$/.test(String(value ?? '').trim());
}
